exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".anonymous{position:relative;top:10px}.m-top-0{margin-top:10px!important}.motive-txt{font-family:Montserrat,sans-serif!important;font-style:normal!important;font-weight:400!important;font-size:14px!important;color:var(--titleBox)!important}.select-input{width:100%;margin-bottom:30px}.select-input label{display:block;font-family:Montserrat,sans-serif;font-style:normal;font-weight:400;font-size:14px;color:#7f8897}.select-input select{width:100%;height:36px;padding:6px 12px;background-color:#fff;border:1px solid #c2cad8;border-radius:4px;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b4de20a4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/views/modals/modalFeedback.vue
// module id = 1066
// module chunks = 0